import { Component, OnInit, signal, ViewChild } from '@angular/core';
import { ToetsA, ToetsComponent, ToetsI } from '../../../dashboards/toets/toets.component';
import { AttrPath } from '@cumlaude/metadata';
import { BasicFilterExpression, FilterExpression } from '../../../services/data.service';
import { DashboardMedewerker, MedewerkerDetail } from '../../Details';
import { isNil, memoize } from 'lodash-es';
import { SingleSelectDropdownComponent } from '@cumlaude/shared-components-inputs';
import { Option, getSchooljaarForDate, getSchooljaarTovHuidig } from '@cumlaude/shared-utils';
import { DetailsDashboard } from '../../base-details-panel/details.dashboard';
import { lastValueFrom, ReplaySubject } from 'rxjs';
import { take } from 'rxjs/operators';
import { ExportOptions } from '../../../services/export.service';
import { Path } from '../../../services/data-tree';
import { DashboardContext } from '../../../shared/dashboard/base-dashboard/dashboard-context';
import { AsyncPipe } from '@angular/common';
import { PivotTableComponent } from '../../../shared/dashboard/pivot-table/pivot-table.component';
import { DashboardHeaderComponent } from '../../../dashboard-header/dashboard-header.component';
import { FilterPanelComponent } from '../../../filter-panel/filter-panel.component';
import { CijferkolomKeuze } from '../../../services/weergave-opties';
import { DataRow } from '../../../shared/dashboard/data-tree-table/data-tree-table';
import { TableModel } from '../../../shared/components/table/table/table.model';
import { FilterBarComponent } from '../../../filter-bar/filter-bar.component';
import { FilterName } from '../../../services/filter-name';
import { LegendaComponent } from '../../../legenda/legenda.component';

@Component({
	selector: 'app-docent-toets-details-panel',
	templateUrl: './docent-toets-details-panel.component.html',
	styleUrls: ['./docent-toets-details-panel.component.scss'],
	imports: [
		FilterPanelComponent,
		DashboardHeaderComponent,
		PivotTableComponent,
		AsyncPipe,
		FilterBarComponent,
		SingleSelectDropdownComponent,
		LegendaComponent,
	],
})
export class DocentToetsDetailsPanelComponent extends ToetsComponent implements OnInit, DetailsDashboard<MedewerkerDetail> {
	override fixedBeforeGroups = 1;

	override flexibleMaxGroups = 1;

	override flexibleGroupsRemovable = false;

	medewerker$ = new ReplaySubject<DashboardMedewerker>(1);

	override availableGroups: AttrPath[] = [['cf_nm_lesgroep'], ['cf_nm_vak']];

	override toetsFilters: FilterName[] = [
		'cf_nm_schooljaar', //
		'cf_is_alternatievenormering',
		'x_details_periode',
		'cf_co_kolom',
		'cf_nm_vak',
	];

	override readonly cijferkolomKeuzeOpties = signal<Option<CijferkolomKeuze>[]>(
		[CijferkolomKeuze.ALLE, CijferkolomKeuze.TOETS, CijferkolomKeuze.GEMIDDELDE].map((val) => new Option(val))
	);

	@ViewChild(LegendaComponent)
	legendaComponent?: LegendaComponent;

	override getRowClickUrl(_context: DashboardContext<ToetsI, ToetsA, ToetsComponent>, _path: Path<ToetsA, number[]>) {
		// Geen zoom-klik voor dit dashboard
		return undefined;
	}

	ngOnInit() {
		this.subscriptions.push(this.filterService.observeAsInput('cf_nm_schooljaar').subscribe((val) => this.qp.dispatch('schooljaar', val)));
	}

	doDetailsExport(exportOptions: ExportOptions) {
		lastValueFrom(this.medewerker$.pipe(take(1))).then((medewerker) =>
			this.doExport(this.filterExpressions(), this.getDashboardFilters(this.permanentFilters(), medewerker.medewerker), exportOptions)
		);
	}

	override enrichTableModel(_context: DashboardContext<ToetsI, ToetsA, ToetsComponent>, tableModel: TableModel<DataRow<ToetsA>>) {
		tableModel.showFooters = false;
	}

	getDashboardFilters = memoize(DocentToetsDetailsPanelComponent._getDashboardFilters, (f, m) => JSON.stringify([f, m]));

	private static _getDashboardFilters(filters: FilterExpression[], medewerker: MedewerkerDetail): FilterExpression[] {
		return [...filters, new BasicFilterExpression(['cf_fks_mw', 'mw_id_medewerker'], medewerker.mw_id_medewerker)];
	}

	getSchooljaarFilterOverride = memoize(DocentToetsDetailsPanelComponent._getSchooljaarFilterOverride);

	private static _getSchooljaarFilterOverride(schooljaarInfo: string) {
		return { cf_nm_schooljaar: schooljaarInfo };
	}

	setSelected(selected: MedewerkerDetail, schooljaar?: string) {
		let targetSchooljaar = schooljaar;
		if (!targetSchooljaar) {
			if (isNil(selected.mw_fun_d_uitdienst)) targetSchooljaar = getSchooljaarTovHuidig();
			else targetSchooljaar = getSchooljaarForDate(new Date(selected.mw_fun_d_uitdienst));
		}

		this.medewerker$.next({
			medewerker: selected,
			schooljaarInfo: targetSchooljaar,
		});
	}
}
